import React, { useState, useEffect, Suspense, useMemo, lazy } from "react";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import BlankLayout from "./layout/blanklayout/BlankLayout";
import FullLayout from "./layout/full-layout/FullLayout";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

// SEO Pages (Lazy loaded for optimal code splitting & reduced TBT)
const BestCreativeAdvertisingAgencyInHyderabad = lazy(() => import("./features/seo-pages/BestCreativeAdvertisingAgencyInHyderabad"));
const BestDigitalMarketingAgencyInHyderabad = lazy(() => import("./features/seo-pages/BestDigitalMarketingAgencyInHyderabad"));
const BestPerformanceMarketingAgencyInHyderabad = lazy(() => import("./features/seo-pages/BestPerformanceMarketingAgencyInHyderabad"));
const BestSeoCompanyInHyderabad = lazy(() => import("./features/seo-pages/BestSeoCompanyInHyderabad"));
const BrandingAgencyInHyderabad = lazy(() => import("./features/seo-pages/BrandingAgencyInHyderabad"));
const CreativeAdvertisingAgencyInHyderabad = lazy(() => import("./features/seo-pages/CreativeAdvertisingAgencyInHyderabad"));
const DigitalMarketingAndBrandingServicesInHyderabad = lazy(() => import("./features/seo-pages/DigitalMarketingAndBrandingServicesInHyderabad"));
const PerformanceMarketingAgencyInHyderabad = lazy(() => import("./features/seo-pages/PerformanceMarketingAgencyInHyderabad"));
const SearchEngineMarketingAgencyInHyderabad = lazy(() => import("./features/seo-pages/SearchEngineMarketingAgencyInHyderabad"));
const SeoCompanyInHyderabad = lazy(() => import("./features/seo-pages/SeoCompanyInHyderabad"));
const SocialMediaMarketingCompanyInHyderabad = lazy(() => import("./features/seo-pages/SocialMediaMarketingCompanyInHyderabad"));
const WebsiteDevelopmentCompanyInHyderabad = lazy(() => import("./features/seo-pages/WebsiteDevelopmentCompanyInHyderabad"));
const WhatsappMarketingCompanyInHyderabad = lazy(() => import("./features/seo-pages/WhatsappMarketingCompanyInHyderabad"));
const SeoThankYou = lazy(() => import("./features/seo-pages/SeoThankYou"));
const Sitemap = lazy(() => import("./features/seo-pages/Sitemap"));

// Blog Pages (Lazy loaded)
const HowToChooseTheRightDigitalMarketingAgencyForYourBusiness = lazy(() => import("./features/blog-pages/HowToChooseTheRightDigitalMarketingAgencyForYourBusiness"));
const HowAiIsTransformingDigitalMarketingIn2026 = lazy(() => import("./features/blog-pages/HowAiIsTransformingDigitalMarketingIn2026"));
const SeoVsPpcWhichIsBetterForBusinessGrowth = lazy(() => import("./features/blog-pages/SeoVsPpcWhichIsBetterForBusinessGrowth"));

function App() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const helmetContext = {};

  const ProtectedRoute = useMemo(() => {
    return ({ children }) => {
      const loggedUser = users.find((user) => user.role === "admin");
      console.log("loggedUser-div:", loggedUser);
      return loggedUser ? children : <Navigate to="/login" />;
    };
  }, [users]);

  useEffect(() => {
    axios
      .get("https://server.grank.co.in/api/v1/users", { timeout: 3000 })
      .then((res) => {
        setUsers(res?.data || []);
      })
      .catch((err) => {
        console.log("Users API notice:", err?.message || err);
      });
  }, []);

  return (
    <>
      <HelmetProvider context={helmetContext}>
        <Suspense fallback={<div>Loading components...</div>}>
          <Routes>
            {/* SEO Pages from cpanel_files */}
            <Route path="/best-creative-advertising-agency-in-hyderabad" element={<BestCreativeAdvertisingAgencyInHyderabad />} />
            <Route path="/best-digital-marketing-agency-in-hyderabad" element={<BestDigitalMarketingAgencyInHyderabad />} />
            <Route path="/best-performance-marketing-agency-in-hyderabad" element={<BestPerformanceMarketingAgencyInHyderabad />} />
            <Route path="/best-seo-company-in-hyderabad" element={<BestSeoCompanyInHyderabad />} />
            <Route path="/branding-agency-in-hyderabad" element={<BrandingAgencyInHyderabad />} />
            <Route path="/creative-advertising-agency-in-hyderabad" element={<CreativeAdvertisingAgencyInHyderabad />} />
            <Route path="/digital-marketing-agency-in-hyderabad" element={<Navigate to="/" replace />} />
            <Route path="/digital-marketing-and-branding-services-in-hyderabad" element={<DigitalMarketingAndBrandingServicesInHyderabad />} />
            <Route path="/performance-marketing-agency-in-hyderabad" element={<PerformanceMarketingAgencyInHyderabad />} />
            <Route path="/search-engine-marketing-agency-in-hyderabad" element={<SearchEngineMarketingAgencyInHyderabad />} />
            <Route path="/seo-company-in-hyderabad" element={<SeoCompanyInHyderabad />} />
            <Route path="/social-media-marketing-company-in-hyderabad" element={<SocialMediaMarketingCompanyInHyderabad />} />
            <Route path="/website-development-company-in-hyderabad" element={<WebsiteDevelopmentCompanyInHyderabad />} />
            <Route path="/whatsapp-marketing-company-in-hyderabad" element={<WhatsappMarketingCompanyInHyderabad />} />
            <Route path="/seo-thankyou" element={<SeoThankYou />} />
            <Route path="/sitemap.php" element={<Sitemap />} />
            <Route path="/sitemap" element={<Sitemap />} />

            {/* Blog Pages from G-Rank Blogs Content.docx */}
            <Route path="/how-to-choose-the-right-digital-marketing-agency-for-your-business" element={<HowToChooseTheRightDigitalMarketingAgencyForYourBusiness />} />
            <Route path="/how-ai-is-transforming-digital-marketing-in-2026" element={<HowAiIsTransformingDigitalMarketingIn2026 />} />
            <Route path="/seo-vs-ppc-which-is-better-for-business-growth" element={<SeoVsPpcWhichIsBetterForBusinessGrowth />} />

            <Route path="/*" element={<BlankLayout />} />
            <Route
              path="/secured/*"
              element={
                <ProtectedRoute>
                  <FullLayout />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Suspense>
      </HelmetProvider>
      <a
        href="https://wa.me/919963391666?text=Hello"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <WhatsAppIcon className="whatsapp-icon" />
      </a>
    </>
  );
}

export default App;
